import { FC, memo } from 'react';

import { AdaptiveFormRows } from '../AdaptiveFormRows';
import { AdaptiveFormConfig } from '../types';

interface ColumnsContainerProps {
  fields?: AdaptiveFormConfig;
  columns: number;
  context?: any;
}

export const ColumnsContainer: FC<ColumnsContainerProps> = memo(
  ({ fields, columns, context }) => {
    return (
      <AdaptiveFormRows
        config={fields || []}
        context={context}
        columns={columns}
        withDefaultWrapper={false}
      />
    );
  }
);

ColumnsContainer.displayName = 'ColumnsContainer';
